import { render, staticRenderFns } from "./recruit_footer.vue?vue&type=template&id=087dd2b0&scoped=true&"
import script from "./recruit_footer.vue?vue&type=script&lang=js&"
export * from "./recruit_footer.vue?vue&type=script&lang=js&"
import style0 from "./recruit_footer.vue?vue&type=style&index=0&id=087dd2b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087dd2b0",
  null
  
)

export default component.exports